import React, { Component } from 'react';

import { Avatar, Flexbox, FontAwesomeIcon } from '@schoolinks/ui-components';
import { shape } from 'prop-types';

import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile';
import { faSackDollar } from '@fortawesome/pro-regular-svg-icons/faSackDollar';
import { faArrowDownToLine } from '@fortawesome/pro-solid-svg-icons/faArrowDownToLine';
import { faPenSwirl } from '@fortawesome/pro-solid-svg-icons/faPenSwirl';

import { DEFAULT_STUDENT_LOGO } from 'config_app';

import s from './RenderAvatar.css';

export default class RenderAvatar extends Component {
  render() {
    const {
      notification: { notificationType, fromUser, image },
    } = this.props;
    const { firstName, lastName } = { ...fromUser };

    if (notificationType === 'student_receive_document') {
      return (
        <Flexbox
          alignItems="center"
          justifyContent="center"
          className={s.iconContainer}
          flexShrink={0}
        >
          <FontAwesomeIcon icon={faFile} color="white" size="lg" />
        </Flexbox>
      );
    }
    if (
      ['to_do_due_this_week', 'to_do_due_tomorrow'].includes(notificationType)
    ) {
      return (
        <FontAwesomeIcon
          icon={faPenSwirl}
          color="blueDark"
          className={s.icon}
        />
      );
    }
    if (
      [
        'scholarship_app_due_this_week',
        'scholarship_app_due_tomorrow',
      ].includes(notificationType)
    ) {
      return (
        <FontAwesomeIcon
          icon={faSackDollar}
          color="blueDark"
          className={s.icon}
        />
      );
    }
    if (
      [
        'report_download_request_ready',
        'report_download_request_failed',
        'student_ilp_report_download_request_ready',
        'student_resume_download_request_ready',
        'student_resume_download_request_ready_google_drive',
        'application_document_print_request_ready',
        'assessment_download_request_ready',
      ].includes(notificationType)
    ) {
      return (
        <Flexbox
          alignItems="center"
          justifyContent="center"
          className={s.iconContainer}
          flexShrink={0}
        >
          <FontAwesomeIcon icon={faArrowDownToLine} color="white" size="lg" />
        </Flexbox>
      );
    }
    return image ? (
      <Avatar
        className={s.greyAvatar}
        imgProps={{
          onError: e => {
            e.target.src = DEFAULT_STUDENT_LOGO;
          },
        }}
        src={image}
      />
    ) : (
      <Avatar className={s.greyAvatar}>{`${firstName ? firstName[0] : ''}${
        lastName ? lastName[0] : ''
      }`}</Avatar>
    );
  }
}

RenderAvatar.propTypes = {
  notification: shape({}).isRequired,
};
